var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect } from "react";
import "@frameworks/shared-library/stylesheets/components/Orderbook/common/MutualFundTransactionsTable/MutualFundTransactionsTable.scss";
import GenericTableShimmer from "@frameworks/shared-library/components/GenericTableShimmer/GenericTableShimmer";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import emptyFolder from "@frameworks/shared-library/assets/images/markets/emptyFolder.svg";
import noResultsFound from "@frameworks/shared-library/assets/images/markets/noResultsFound.svg";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Aif&PmsSidebar.scss";
import actions from "@redux/feature/Markets/NCD/actions/ProductBouquetActions";
import OfferingsTableCheckboxActions from "@frameworks/shared-library/components/Offerings/Generic/OfferingsTableCheckboxActions/OfferingsTableCheckboxActions";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/shared-library/components/ErrorNotification";
import ErrorNotificationUser from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import somethingWentWrong from "@frameworks/shared-library/assets/images/markets/somethingWentWrong.svg";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { useNavigate } from "react-router-dom";
import { useGoToProductBouquet } from "@frameworks/NCD/Hook/ProductBouquet/useGoToProductBouquet";
import { useProductName } from "@frameworks/NCD/Hook/ProductBouquet/useProductName";
import { useSelector } from "react-redux";
import DynamicPagination from "@frameworks/NCD/Components/Pagination/Pagination";
import { ESubProductIds, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
var ProductBouquetTable = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var showShimmer = props.showShimmer, _v = props.isBookmarkFunctionality, isBookmarkFunctionality = _v === void 0 ? true : _v;
    var subCategoryId = props.subCategoryId;
    var productName = useProductName(subCategoryId);
    var _w = __read(React.useState(false), 2), showSessionPopup = _w[0], setSessionShowPopup = _w[1];
    var cActions = new actions();
    var navigate = useNavigate();
    var _x = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }), productBouquetsubCategoryId = _x.subCategoryId, userUnauthorized = _x.userUnauthorized;
    var _y = __read(React.useState({
        page: 1,
        totalItems: (props === null || props === void 0 ? void 0 : props.totalItems)
            ? props === null || props === void 0 ? void 0 : props.totalItems
            : Math.ceil(((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length) / 10),
        nextPage: 1,
    }), 2), pageObj = _y[0], setPageObj = _y[1];
    var orderbookRef = React.useRef(null);
    var tableRef = React.useRef(null);
    var getCustomLoadMore = function () {
        var _a, _b;
        var customLodeMore = false;
        if (!!(props === null || props === void 0 ? void 0 : props.searchFilterApplied) &&
            (props === null || props === void 0 ? void 0 : props.searchFilterApplied) &&
            ((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length) > 10) {
            customLodeMore = true;
        }
        else {
            if (!!(props === null || props === void 0 ? void 0 : props.searchFilterApplied) && (props === null || props === void 0 ? void 0 : props.searchFilterApplied)) {
                customLodeMore = false;
            }
            else {
                if ((pageObj === null || pageObj === void 0 ? void 0 : pageObj.totalItems) > 10) {
                    customLodeMore = true;
                }
                else if (((_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 : _b.length) > 10) {
                    customLodeMore = true;
                }
            }
        }
        return customLodeMore;
    };
    var getMannualText = function () {
        var condition = false;
        if ((props === null || props === void 0 ? void 0 : props.totalItems) == undefined || (props === null || props === void 0 ? void 0 : props.totalItems) == null) {
            setPageObj(function (pageObj) {
                if ((pageObj === null || pageObj === void 0 ? void 0 : pageObj.totalItems) > (pageObj === null || pageObj === void 0 ? void 0 : pageObj.page) + 1)
                    condition = true;
                return pageObj;
            });
        }
        else {
            if ((props === null || props === void 0 ? void 0 : props.totalItems) > pageObj.page + 1)
                condition = true;
        }
        return condition;
    };
    var calculatePage = function (page) {
        var _a;
        setPageObj(function (pageObj) {
            pageObj.page = page;
            pageObj.nextPage = pageObj.page + 1;
            return pageObj;
        });
        var payload = __assign(__assign({}, props.payloadData), { page_index: 1, page_size: ((_a = props.payloadData) === null || _a === void 0 ? void 0 : _a.page_size) + 10 });
        props === null || props === void 0 ? void 0 : props.paginationButtonCallback(payload);
    };
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.totalItems) !== undefined &&
            (props === null || props === void 0 ? void 0 : props.totalItems) !== null &&
            (props === null || props === void 0 ? void 0 : props.totalItems) > 0) {
            setPageObj(function (pageObj) {
                pageObj.totalItems = props === null || props === void 0 ? void 0 : props.totalItems;
                return pageObj;
            });
        }
    }, [props === null || props === void 0 ? void 0 : props.totalItems]);
    var handleNavigateToOfferings = function () {
        useGoToProductBouquet(subCategoryId || productBouquetsubCategoryId, navigate);
    };
    var generateDefaultError = function () {
        return (React.createElement("div", { className: "custom-error-state flexCenter mx-0 mb-0" },
            React.createElement(Errormsg, { image: emptyFolder, msg: "No results found" })));
    };
    var generateDefaultErrorBookmark = function () {
        return (React.createElement("div", { className: "custom-error-state" },
            React.createElement(Errormsg, { image: noResultsFound, msg: "No saved products", customComp: React.createElement("div", { className: "error-state-button-bar d-flex" },
                    React.createElement("p", { className: "DMSanN_14_400" }, "Explore top performing funds and save for future actions"),
                    React.createElement("div", { className: "d-flex align-items-center justify-content-center" },
                        React.createElement(EdButton, { btnTyp: "tomato-filled-rounded", value: "Explore Funds", onClick: handleNavigateToOfferings }))) })));
    };
    var generateDefaultErrorOrderBook = function () {
        return (React.createElement("div", { className: "custom-error-state" },
            React.createElement(Errormsg, { image: emptyFolder, msg: " ", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                    React.createElement("p", { className: "DMSanN_14_400" },
                        "You don't seem to have any transactions as of now in",
                        " ",
                        productName,
                        "."),
                    React.createElement(EdButton, { btnTyp: "tomato", value: "Invest Now!", className: "d-flex align-items-center justify-content-center DMSanN_13_500 border-radius-30", onClick: handleNavigateToOfferings })) })));
    };
    var isBookMarkButton = props.isBookMark
        ? ((_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 : _b.length) > 0 && ((_c = props.checked) === null || _c === void 0 ? void 0 : _c.length) > 0
        : ((_d = props.checked) === null || _d === void 0 ? void 0 : _d.length) > 0;
    useEffect(function () {
        if (userUnauthorized) {
            var errorCode = userUnauthorized === null || userUnauthorized === void 0 ? void 0 : userUnauthorized.getHttpCode();
            if (errorCode === 401 || errorCode === 403) {
                setSessionShowPopup(true);
            }
        }
    }, [userUnauthorized]);
    var handleCalculateSchemeNameMaxWidth = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        // TODO: This function needs to be refactored more for more proper functionlity
        try {
            if (((_b = (_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.rows) === null || _b === void 0 ? void 0 : _b.length) && ((_c = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _c === void 0 ? void 0 : _c.rows[0].cells)) {
                var totalOccupiedWidthExceptSchemeColumn_1 = (_e = Array.from((_d = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _d === void 0 ? void 0 : _d.rows[0].cells)) === null || _e === void 0 ? void 0 : _e.reduce(function (sum, cell, index) {
                    if (index !== 1) {
                        return sum + cell.offsetWidth;
                    }
                    return sum;
                }, 0);
                var thead = tableRef.current.querySelector("thead");
                var tbody = tableRef.current.querySelector("tbody");
                if (thead) {
                    var secondTh = thead.querySelectorAll("th")[1]; // 0-based index
                    if (secondTh) {
                        secondTh.style.maxWidth = "".concat(((_g = (_f = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _f === void 0 ? void 0 : _f.parentElement) === null || _g === void 0 ? void 0 : _g.clientWidth) -
                            totalOccupiedWidthExceptSchemeColumn_1 -
                            10, "px");
                    }
                }
                if (tbody) {
                    tbody.querySelectorAll("tr").forEach(function (row) {
                        var _a, _b;
                        var secondTd = row.querySelectorAll("td")[1];
                        if (secondTd) {
                            secondTd.style.maxWidth = "".concat(((_b = (_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) -
                                totalOccupiedWidthExceptSchemeColumn_1 -
                                10, "px");
                        }
                    });
                }
            }
        }
        catch (_h) { }
    };
    React.useEffect(function () {
        handleCalculateSchemeNameMaxWidth();
    }, [props === null || props === void 0 ? void 0 : props.data]);
    return (React.createElement(React.Fragment, null,
        ((!!showShimmer && showShimmer) || showShimmer) && (React.createElement(GenericTableShimmer, { rowCount: 40, columnCount: 8, columnsWidthClass: "table-shimmer-col-fr2-1-1-1-1-1-1-1_2" })),
        isBookMarkButton && (React.createElement(OfferingsTableCheckboxActions, { hideAddToCompare: true, bookmarkButtonCallback: function () {
                var _a;
                props.bookmarkButtonCallback
                    ? (_a = props.bookmarkButtonCallback) === null || _a === void 0 ? void 0 : _a.call(props)
                    : function () { };
            }, bookmarkButtonText: (props === null || props === void 0 ? void 0 : props.isBookMark) ? "Remove" : "Bookmark" })),
        ((_e = props.errorData) === null || _e === void 0 ? void 0 : _e.isOpen) && (React.createElement("div", { className: "custom-error-state mb-0" },
            React.createElement(ErrorNotification, { error: (_f = props.errorData) === null || _f === void 0 ? void 0 : _f.error, isOpen: (_g = props.errorData) === null || _g === void 0 ? void 0 : _g.isOpen, displayType: ErrorDisplayType.INSECTION, image: somethingWentWrong, customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                    React.createElement("p", { className: "DMSanN_14_400" }, "Try refreshing the page, or try again later."),
                    React.createElement("button", { className: "align-items-center DMSanN_13_500", onClick: function () { return props === null || props === void 0 ? void 0 : props.tryAgainButtonCallback(); } }, "Try Again")) }))),
        React.createElement("div", { className: "aop_investment p-0 product-bouquet-table ".concat((_h = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _h !== void 0 ? _h : ""), ref: orderbookRef },
            !!(props === null || props === void 0 ? void 0 : props.data) &&
                ((_j = props === null || props === void 0 ? void 0 : props.data) === null || _j === void 0 ? void 0 : _j.length) > 0 &&
                (pageObj === null || pageObj === void 0 ? void 0 : pageObj.totalItems) > 0 &&
                !((_k = props.errorData) === null || _k === void 0 ? void 0 : _k.isOpen) &&
                !showShimmer && (React.createElement(DynamicPagination, __assign({}, props, { viewAll: props.showViewAll, dataLengthPerPage: 10, data: ((_l = props === null || props === void 0 ? void 0 : props.data) === null || _l === void 0 ? void 0 : _l.length) > 0 ? props === null || props === void 0 ? void 0 : props.data : [], parentClassName: "table common-table-border common-compact-table-wrapper", totalItems: props === null || props === void 0 ? void 0 : props.totalItems, infinityScroll: true, rowClassName: function (ele) {
                    var _a;
                    return isBookmarkFunctionality
                        ? ((_a = props === null || props === void 0 ? void 0 : props.checked) === null || _a === void 0 ? void 0 : _a.findIndex(function (x) { return (x === null || x === void 0 ? void 0 : x.isin_id) === (ele === null || ele === void 0 ? void 0 : ele.isin_id); })) === -1
                            ? ""
                            : "bg_aqua_white"
                        : "";
                }, customLoadMore: (props === null || props === void 0 ? void 0 : props.allTabPage) ? false : getCustomLoadMore(), manualNext: (props === null || props === void 0 ? void 0 : props.numberOfDataItemsToShow) ? false : getMannualText(), nextFunction: calculatePage, totalNumberPages: Math.ceil((pageObj === null || pageObj === void 0 ? void 0 : pageObj.totalItems) / 10), paginationLoader: showShimmer, initPageNumber: Math.ceil((pageObj === null || pageObj === void 0 ? void 0 : pageObj.totalItems) / 10), sortIconUp: "edel-icon-arrow-up-thin", sortIconDown: "edel-icon-arrow-down", sortArrowHighlightingColor: "#6374D4", selectedSortColumnVal: (_m = props.payloadData) === null || _m === void 0 ? void 0 : _m.orderby, selectedSortVal: !((_o = props.payloadData) === null || _o === void 0 ? void 0 : _o.orderbydesc) ? "DESC" : "ASC", callbackSorted: props.callbackSorted, tableRef: tableRef }))),
            props.showViewAll &&
                !!(props === null || props === void 0 ? void 0 : props.data) &&
                props.data.length > props.numberOfDataItemsToShow ? (React.createElement(EdButton, { btnTyp: "text-only", onClick: function () {
                    !!(props === null || props === void 0 ? void 0 : props.viewAllOnClick) &&
                        (props === null || props === void 0 ? void 0 : props.viewAllOnClick(props === null || props === void 0 ? void 0 : props.parentId, String(props === null || props === void 0 ? void 0 : props.subCategoryId)));
                    if (props === null || props === void 0 ? void 0 : props.isOrderBook) {
                        cActions.updateSubCategoryId(String(props.subCategoryId));
                    }
                }, className: "DMSanN_16_400 txt-han-blue tables-viewAll-button mgt-15 mgb-15", value: React.createElement("span", { className: "d-flex align-items-center gap-2 mgl-12" },
                    React.createElement("span", { className: "text-decoration-underline" }, "View All"),
                    React.createElement("i", { className: "edel-icon-arrow-right" })) })) : (React.createElement(React.Fragment, null)),
            (props === null || props === void 0 ? void 0 : props.isBookMark) &&
                !showShimmer &&
                ((props === null || props === void 0 ? void 0 : props.data) == null ||
                    (props === null || props === void 0 ? void 0 : props.data) == undefined ||
                    (((_p = props === null || props === void 0 ? void 0 : props.data) === null || _p === void 0 ? void 0 : _p.length) == 0 &&
                        !((_q = props.errorData) === null || _q === void 0 ? void 0 : _q.isOpen) &&
                        generateDefaultErrorBookmark())),
            (props === null || props === void 0 ? void 0 : props.isOrderBook) &&
                !showShimmer &&
                ((props === null || props === void 0 ? void 0 : props.data) == null ||
                    (props === null || props === void 0 ? void 0 : props.data) == undefined ||
                    (((_r = props === null || props === void 0 ? void 0 : props.data) === null || _r === void 0 ? void 0 : _r.length) == 0 &&
                        !((_s = props.errorData) === null || _s === void 0 ? void 0 : _s.isOpen) &&
                        generateDefaultErrorOrderBook())),
            !(props === null || props === void 0 ? void 0 : props.isBookMark) &&
                !showShimmer &&
                !(props === null || props === void 0 ? void 0 : props.isOrderBook) &&
                ((props === null || props === void 0 ? void 0 : props.data) == null ||
                    (props === null || props === void 0 ? void 0 : props.data) == undefined ||
                    (((_t = props === null || props === void 0 ? void 0 : props.data) === null || _t === void 0 ? void 0 : _t.length) == 0 &&
                        !((_u = props.errorData) === null || _u === void 0 ? void 0 : _u.isOpen) &&
                        generateDefaultError()))),
        (props === null || props === void 0 ? void 0 : props.detailsSidebarComponent) ? props === null || props === void 0 ? void 0 : props.detailsSidebarComponent : null,
        showSessionPopup &&
            (props === null || props === void 0 ? void 0 : props.isOrderBook) &&
            ESubProductIds.StructuredProducts !== props.subCategoryId && (React.createElement(ErrorNotificationUser, { displayType: ErrorDisplayType.POPUP, showSessionPopup: showSessionPopup, onClose: function () {
                setSessionShowPopup(false);
                cActions.userUnauthorized(null);
            } })),
        showSessionPopup && !(props === null || props === void 0 ? void 0 : props.isOrderBook) && (React.createElement(ErrorNotificationUser, { displayType: ErrorDisplayType.POPUP, showSessionPopup: showSessionPopup, onClose: function () {
                setSessionShowPopup(false);
                cActions.userUnauthorized(null);
            } }))));
};
export default ProductBouquetTable;
